module.exports = __webpack_public_path__ + "static/media/white-renewables.aee94df7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-renewables.svg
// module id = 312
// module chunks = 0